export function changeFilteredInfo(searchArr) {
    let filter = {}
    searchArr.map(item => {
        if (['至', '~', '——'].some(range => item.value.includes(range))) {
            let splitString = item.value.includes('至') ? '至' : item.value.includes('~') ? '~' : '——'
            filter[item.key] = item.value.split(splitString).map(item=>typeof item==='string'?item.trim():item)
        } else {
            filter[item.key] = [item.value]
        }
    })
    return filter
}
import BigNumber from 'bignumber.js';
export function compareNumbers(a, b) {
    const numA = new BigNumber(a);
    const numB = new BigNumber(b);

    if (numA.isGreaterThan(numB)) return 1;
    if (numA.isLessThan(numB)) return -1;
    return 0;
}
